/********************
 ACTIONS
 ********************/
 import { SET_LOADER } from "./types";

 export const showLoader = (loader) => ({
   type: SET_LOADER,
   loader,
 });
 